import type { Prototype } from "../prototype-types";

export const jamesBaoPrototypes: Prototype[] = [
  {
    id: "jba-faire-pdp-review-placements",
    name: "PDP Product Review Placements",
    path: "/jba/faire-pdp-review-placements",
    description:
      "Explores where product reviews could surface on the retailer PDP",
    owner: "James Bao",
    createdAt: "2026-08-19",
    lastUpdated: "2026-08-19",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/jba-faire-pdp-product-reviews.png",
    creationTool: "cursor",
  },
  {
    id: "jba-faire-pdp-product-reviews",
    name: "Faire PDP Product Reviews",
    path: "/jba/faire-pdp-product-reviews",
    description:
      "Mockup of a Faire PDP with product reviews surfaced in the top banner",
    owner: "James Bao",
    createdAt: "2026-05-28",
    lastUpdated: "2026-05-28",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.faire.com/fastly/3237a9a4a528f10223b06826bf6a3c1f518ecf42a983956d148bd6b53df94b30.png",
    creationTool: "claude-code",
  },
  {
    id: "jba-faire-source-product-reviews",
    name: "Faire Source Product Reviews",
    path: "/jba/faire-source-product-reviews",
    description:
      "Mockup of the Faire Source page showing product reviews instead of brand reviews",
    owner: "James Bao",
    createdAt: "2026-05-27",
    lastUpdated: "2026-05-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.faire.com/fastly/68dcc81f596ac8bed4f8dec08cc3300b5decee42f0b1eae0f0f7606e4398edc9.png",
    creationTool: "claude-code",
  },
];
